// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2jlXv","sendOtp":"AuthorizeToLogin_sendOtp__3HPYW"};